import { Notify } from "vant";
import { getSms, getShop, insertVip } from "@/api/vip";

export default {
  namespaced: true,
  actions: {
    async getSms(context, params = {}) {
      const res = await getSms(params);
      if (res.code !== 0) {
        Notify({ type: "danger", message: res.msg });
      }
      return res;
    },

    async getShop(context, params = {}) {
      const { data, code, msg } = await getShop(params);
      if (code !== 0) {
        Notify({ type: "danger", message: msg });
      }
      return data;
    },

    async insertVip(context, params = {}) {
      const res = await insertVip(params);
      if (res.code !== 0) {
        Notify({ type: "danger", message: res.msg });
      }
      return res;
    }
  }
};
